import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import GenreSection from "./components/GenreSection";
import RatingSection from "./components/RatingSection";
import WorksSection from "./components/WorksSection";
import UncutSection from "./components/UncutSection";
import NatureSection from "./components/NatureSection";
import DirectorSection from "./components/DirectorSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <IntroSection />
        <GenreSection />
        <RatingSection />
        <WorksSection />
        <UncutSection />
        <NatureSection />
        <DirectorSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}